module.exports = __webpack_public_path__ + "img/voucher-overview-aa028be.jpg";